import dynamic from 'next/dynamic'
import { HeaderPlaceholder } from '@/features/shared/components/Headers/Header/HeaderPlaceholder'

export const DynamicHeader = dynamic(
  async () => (await import('@/features/shared/components/Headers/Header')).Header,
  { loading: () => <HeaderPlaceholder /> },
)
